import { AxiosRequestConfig } from "axios";
import { AXIOS_INSTANCE, BASE_URL } from "../App";

export default async function DeleteBank(salesOrg: string, bankGuid: string) {
    //console.log("-----------------",salesOrg,bankGuid)
  const config: AxiosRequestConfig = {
    method: "POST",
    params: {
      clientId: "100",
      salesOrg,
      bankGuid,
    },
    url: `${BASE_URL}/api/bank/delete`,
  };

  return await AXIOS_INSTANCE(config).then((v) => v.data);
}
